import * as React from "react";
import { cn } from "@/lib/utils";

const Textarea = ({
    className,
    ...props
}: React.ComponentProps<"textarea">) => {
    return (
        <textarea
            className={cn(
                "rounded-default border-input-default bg-input-default px-default py-narrow placeholder:text-subtler hover:not-focus:bg-input-hover active:bg-input-press disabled:bg-input-disabled flex min-h-[80px] w-full border ring-offset-0 ring-inset disabled:cursor-not-allowed",
                className,
            )}
            {...props}
        />
    );
};

Textarea.displayName = "Textarea";

export { Textarea };
